(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobileViewport = window.matchMedia('(max-width: 767px)');

  const updateVideo = (video) => {
    const desktopOnly = video.classList.contains(
      'kickass-collection-banner__video--desktop',
    );
    const mobileOnly = video.classList.contains(
      'kickass-collection-banner__video--mobile',
    );
    const hiddenAtViewport =
      (desktopOnly && mobileViewport.matches) ||
      (mobileOnly && !mobileViewport.matches);

    if (reducedMotion.matches || hiddenAtViewport) {
      video.pause();
      return;
    }

    video.play().catch(() => {
      // Autoplay can be blocked by browser or device settings.
    });
  };

  const init = (scope = document) => {
    scope
      .querySelectorAll('.kickass-collection-banner__video')
      .forEach(updateVideo);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  reducedMotion.addEventListener('change', () => init());
  mobileViewport.addEventListener('change', () => init());
})();
